import { registerDestructor } from '@ember/destroyable';

import Modifier from 'ember-modifier';
import Swiper from 'swiper';

const destroySwiper = (instance) => {
  instance.swiper?.destroy();
};

export default class SwiperModifier extends Modifier {
  // Defaults
  swiper;

  // Hooks
  modify(element, _positionalArgs, { items, initialOptions, trackedOptions }) {
    if (this.swiper) {
      for (const [key, value] of Object.entries(trackedOptions)) {
        this.swiper[key] = value;
      }

      if (items) {
        this.swiper.update();
      }
    } else {
      this.swiper = new Swiper(element, initialOptions);
    }

    registerDestructor(this, destroySwiper);
  }
}
